import { Component, OnInit, OnDestroy} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../core/services/common.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-sidebar-component',
  imports: [CommonModule],
  templateUrl: './sidebar-component.html',
  styleUrl: './sidebar-component.scss'
})
export class SidebarComponent implements OnInit, OnDestroy {
  silverpushLogo = 'assets/img/logo.svg';
  silverpush = 'assets/img/silverpush.svg';
  contentPool = 'assets/img/content-pool-icon.svg';
  segment = 'assets/img/segment-list-icon.svg';
  user = 'assets/img/user-management-icon.svg';
  report = 'assets/img/report.png';
  security = 'assets/img/segment-permission-icon.svg';

  opensideBar = false;
  userData: any = {}
  currentRoutePathObservable:string = '';

  private userSubscription: Subscription = new Subscription();
  private routerSubscription: Subscription = new Subscription();


  constructor(private _commonService:CommonService, private _router: Router) {}


  ngOnInit() {
    this._commonService.changeSideToggle(this.opensideBar)
    this.userSubscription = this._commonService.getUserDetail().subscribe((user: any) => {
      this.userData = user;
    })
    this.currentRoutePathObservable = this._router.url.startsWith('/') ? this._router.url.slice(1) : this._router.url

    this.routerSubscription = this._router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoutePathObservable = event.urlAfterRedirects.startsWith('/')
          ? event.urlAfterRedirects.slice(1)
          : event.urlAfterRedirects
      })
  }


  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
   
  }

  toggleSidebar(): void {
    this.opensideBar = !this.opensideBar;
    this._commonService.changeSideToggle(this.opensideBar)
  }

  navigation(path: string) {
    this._router.navigate([path]);
  }
}
